import React from "react";
// core components
import { Col, Row } from 'reactstrap';

import { FaFileExport } from 'react-icons/fa'

import PropTypes from "prop-types";

import commonStyle from "commonStyle";

import Button from "components/Button";

import { withoutAuth } from "HOC";

import './index.css';

export default class Sidebar extends React.Component {
  renderSingleSidebar = () => (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <hr style={{ width: '100%' }}/>
      <div
        className='sidebar-action-text-container'
      >
        <Row>
          <p
            className='sidebar-action-text'
            style={{ height: 20, color: commonStyle.primaryColor}}
            onClick={this.props.onRestore}
          >
            <FaFileExport />
            <span style={{ paddingLeft: 7, fontWeight: 400 }}>Restore</span>
          </p>
        </Row>
      </div>
    </div>
  );

  renderMulitpleSidebar = () => (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <hr style={{ width: '100%' }}/>
      <div
        className='sidebar-action-text-container'
      >
        <Row>
          <p
            className='sidebar-action-text'
            style={{ height: 20, color: commonStyle.primaryColor}}
            onClick={this.props.onRestore}
          >
            <FaFileExport />
            <span style={{ paddingLeft: 7, fontWeight: 400 }}>Restore all</span>
          </p>
        </Row>
      </div>
    </div>
  );

  renderSidebar = ({ oneSelected, multipleSelected }) => {
    let component = null;

    if (oneSelected) {
      component = this.renderSingleSidebar();
    } else if (multipleSelected) {
      component = this.renderMulitpleSidebar();
    } else {
      component = null;
    }

    return component;
  }

  render() {
    return this.renderSidebar(this.props);
  }
}
